import {
  GET_PAYMENT_MODE_FAILED,
  GET_PAYMENT_MODE_NOT_FOUND,
  GET_PAYMENT_MODE_SUCCESS,
  GET_PAYMENT_MODE_INVALID_REQUEST,
  LOAD_PAYMENT_MODE,
  RESET_PAYMENT_MODE,
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  failed: false,
  invalidRequest: false,
  success: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PAYMENT_MODE:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        failed: false,
      };

    case GET_PAYMENT_MODE_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        success: false,
        invalidRequest: false,
        failed: false,
        data: [],
      };

    case GET_PAYMENT_MODE_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        notFound: false,
        success: false,
        invalidRequest: false,
      };
    case GET_PAYMENT_MODE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        success: false,
        notFound: false,
      };
    case GET_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        invalidRequest: false,
        failed: false,
        success: true,
        data: action.payload,
      };

    case RESET_PAYMENT_MODE:
      return (state = initialState);

    default:
      return state;
  }
};
